/* VELTRIO: make product-card images load reliably on phones.
   Lazy images are switched to eager shortly before they are needed (look-ahead),
   and the rest are fetched quietly after the page has finished loading. */
(function () {
  'use strict';
  var SEL = '.card-wrapper img[loading="lazy"], .veltrio-card img[loading="lazy"]';
  var conn = navigator.connection || {};
  var saveData = conn.saveData === true;

  function retryOnce(img) {
    img.addEventListener('error', function () {
      if (img.getAttribute('data-vl-retry')) return;
      img.setAttribute('data-vl-retry', '1');
      setTimeout(function () {
        var s = img.getAttribute('src');
        if (!s) return;
        img.removeAttribute('srcset');
        img.setAttribute('src', s);
      }, 1500);
    });
  }

  function load(img) {
    if (img.getAttribute('data-vl')) return;
    img.setAttribute('data-vl', '1');
    retryOnce(img);
    img.loading = 'eager';
  }

  function pending() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (i) {
      return !i.getAttribute('data-vl');
    });
  }

  function start() {
    var list = pending();
    if (!list.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '2500px 0px' });
      list.forEach(function (i) { io.observe(i); });
    }

    if (saveData) return;

    function batch() {
      var left = pending();
      if (!left.length) return;
      left.sort(function (a, b) {
        return Math.abs(a.getBoundingClientRect().top) - Math.abs(b.getBoundingClientRect().top);
      });
      left.slice(0, 6).forEach(load);
      setTimeout(batch, 400);
    }
    setTimeout(batch, 1200);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();